import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import tw from "tailwind-styled-components";
const FieldLabel = tw.label`
  ${({ $color, $size, $margin })=>{
    return `
      flex
      flex-row
      justify-between
      items-center

      mb-2
      ${$margin ? `${$margin}` : ""}

      pl-1
      w-full
      ${$color ?? "text-white"}
      ${!$color ? "text-opacity-70" : ""}
      ${`text-${$size || "sm"}`}
    `;
}}
`;
const SLabel = ({ children, color, size = "sm", margin = "", htmlFor = undefined })=>{
    const props = {
        $color: color,
        $size: size,
        $margin: margin,
        htmlFor: htmlFor
    };
    return /*#__PURE__*/ _jsx(FieldLabel, {
        ...props,
        children: children
    });
};
const Container = tw.div`
  flex
  flex-col
  relative
  ${(p)=>p.$noMargin ? "" : "mb-3"}
  w-full
`;
const SField = ({ children, noMargin = false })=>{
    return /*#__PURE__*/ _jsx(Container, {
        $noMargin: noMargin,
        children: children
    });
};
SField.Label = SLabel;
export { SField };
